import { useEffect, useState } from "react";
import axios from "axios";
import { sermons as mockSermons } from "../mock";
import { Play, X, Calendar, User, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Sermons() {
  const [active, setActive] = useState(null);
  const [sermons, setSermons] = useState(mockSermons);
  useEffect(() => {
    axios.get(`${API}/sermons`).then(r => { if (r.data?.length) setSermons(r.data); }).catch(() => {});
  }, []);
  if (!sermons.length) return null;
  const featured = sermons[0];
  const rest = sermons.slice(1, 4);

  return (
    <section id="sermons" className="py-24 md:py-28 bg-[#f5f7f9] text-[#0a2d38]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-6">
          <div>
            <div className="text-[#c8a36a] uppercase tracking-[0.32em] text-xs font-bold mb-3">Sermons & Messages</div>
            <h2 className="text-4xl md:text-5xl font-bold leading-[1.05] tracking-tight">
              The Word, <span className="text-[#c8a36a]">unfiltered.</span>
            </h2>
          </div>
          <a href="/videos" className="text-sm font-bold text-[#0a2d38] hover:text-[#c8a36a] inline-flex items-center gap-2">
            View all sermons <ArrowRight className="h-4 w-4" />
          </a>
        </div>

        <div className="grid lg:grid-cols-5 gap-6">
          <button onClick={() => setActive(featured)} className="lg:col-span-3 group relative overflow-hidden rounded-md text-left shadow-[0_20px_50px_-30px_rgba(10,45,56,0.25)]">
            <img src={`https://i.ytimg.com/vi/${featured.youtubeId}/maxresdefault.jpg`} alt={featured.title}
              onError={(e) => { e.currentTarget.src = `https://i.ytimg.com/vi/${featured.youtubeId}/hqdefault.jpg`; }}
              className="w-full h-[360px] md:h-[440px] object-cover group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a2d38] via-[#0a2d38]/40 to-transparent" />
            <div className="absolute top-5 left-5 px-3 py-1.5 bg-[#c8a36a] text-[#0a2d38] text-[10px] font-bold uppercase tracking-[0.22em] rounded-full">Latest</div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-20 w-20 rounded-full bg-white/25 backdrop-blur border border-white/40 flex items-center justify-center group-hover:bg-[#c8a36a] group-hover:border-[#c8a36a] transition-colors">
                <Play className="h-7 w-7 ml-1 text-white" />
              </div>
            </div>
            <div className="absolute bottom-0 inset-x-0 p-6 md:p-8 text-white">
              <div className="text-[#f0d9a8] text-xs uppercase tracking-[0.28em] font-bold mb-2">{featured.series}</div>
              <h3 className="text-2xl md:text-3xl font-bold mb-3">{featured.title}</h3>
              <div className="flex items-center gap-5 text-sm text-white/85">
                <span className="flex items-center gap-2"><User className="h-4 w-4" />{featured.speaker}</span>
                <span className="flex items-center gap-2"><Calendar className="h-4 w-4" />{featured.date}</span>
              </div>
            </div>
          </button>

          <div className="lg:col-span-2 flex flex-col gap-4">
            {rest.map((s) => (
              <button key={s.id} onClick={() => setActive(s)} className="group flex items-stretch gap-4 bg-white hover:bg-[#faf7f2] border border-[#e8ecef] hover:border-[#c8a36a] rounded-md p-3 text-left transition-colors">
                <div className="relative h-24 w-32 flex-shrink-0 overflow-hidden rounded-sm">
                  <img src={`https://i.ytimg.com/vi/${s.youtubeId}/hqdefault.jpg`} alt={s.title} className="h-full w-full object-cover" />
                  <div className="absolute inset-0 bg-black/25 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                    <Play className="h-5 w-5 text-white" />
                  </div>
                </div>
                <div className="flex-1 py-1">
                  <div className="text-[10px] uppercase tracking-[0.28em] text-[#c8a36a] font-bold mb-1">{s.series}</div>
                  <div className="text-[15px] font-semibold text-[#0a2d38] leading-snug mb-1.5 line-clamp-2">{s.title}</div>
                  <div className="text-xs text-[#7a8a8f]">{s.date}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      {active && (
        <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <div className="relative w-full max-w-5xl aspect-video bg-black rounded-md overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setActive(null)} className="absolute -top-12 right-0 text-white hover:text-[#c8a36a] flex items-center gap-2 text-sm">
              Close <X className="h-5 w-5" />
            </button>
            <iframe
              title={active.title}
              src={`https://www.youtube.com/embed/${active.youtubeId}?autoplay=1`}
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
}
